import { Grid } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { Line } from 'core/components';
import { ICorporatePart } from 'corporate/types';

interface IProps {
  corporatePart: Partial<ICorporatePart>;
}

export const UomDetails = ({ corporatePart }: IProps) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Line label={t('labelBase')} value={corporatePart.uom} justifyContent="flex-start" />
      <Line
        label={t('labelPurchase')}
        value={corporatePart.purchaseCostUom}
        justifyContent="flex-start"
      />
      <Line label={t('labelSales')} value={corporatePart.salesUom} justifyContent="flex-start" />
      <Line
        label={t('labelAlternateSales')}
        value={corporatePart.alternateSalesUom}
        justifyContent="flex-start"
      />
      <Line
        label={t('labelPackage')}
        value={corporatePart.packageUom}
        justifyContent="flex-start"
      />
      <Line
        label={t('labelExternalErp')}
        value={corporatePart.externalUom}
        justifyContent="flex-start"
      />
      <Line label={t('labelSku')} value={corporatePart.alternateUom} justifyContent="flex-start" />
    </Grid>
  );
};
